import React, { Component } from 'react'

export class Contests extends Component {
  render() {
    return (
      <div>Contests</div>
    )
  }
}

export default Contests